export default __webpack_public_path__ + "static/media/guard5.af1b5a2d.png";